class FolderListCtrl {
  constructor($scope, TemplateService) {
    'ngInject';
    this.breadcrumbs = [];
    this.$scope = $scope;
    this.ts = TemplateService;
  }

  $onInit() {
    this.updateBreadcrumbs();
    this.$scope.$watch('$ctrl.activeFolderId', (newVal, oldVal) => {
      if (newVal !== oldVal) {
        this.updateBreadcrumbs();
      }
    });
    this.$scope.$watch('$ctrl.folders', () => {
      this.updateBreadcrumbs();
    }, true);
    this.$scope.$watch('$ctrl.searchTerm', () => {
      this.updateBreadcrumbs();
    });
  }

  updateBreadcrumbs() {
    this.breadcrumbs = [];
    if (!this.folders) return;
    if (!this.activeFolderId) {
      if (this.searchTerm && this.searchTerm.trim()) {
        this.breadcrumbs = [{ id: '', title: 'Home' }];
      }
      return;
    }
    
    const path = this.ts.getFolderPath(this.activeFolderId, this.folders);

    // Add Root at the beginning
    this.breadcrumbs = [{ id: '', title: 'Home' }, ...path];
  }

  onBreadcrumbClick(folderId) {
    this.activeFolderId = folderId;
    if (this.onBreadcrumbClickCallback) {
      this.onBreadcrumbClickCallback({ folderId });
    }
  }

  newFolder() {
    this.onNewFolder({parentId: this.activeFolderId});
  }

  removeFolder() {
    this.onRemoveFolder();
  }

  folderSettings() {
    this.onFolderSettings();
  }
}

export default {
  bindings:{
    folders: '<',
    activeFolderId: '=',
    searchTerm: '<?',
    onNewFolder: '&',
    onRemoveFolder: '&',
    onFolderSettings: '&',
    onBreadcrumbClickCallback: '&?'
  },
  templateUrl: 'record-utilities/folder-list/folder-list.component.html',
  controller: FolderListCtrl
}